export const USER_DATA = "userData";
export const ERROR_MESSAGE = "errorMessage";